import { ProgramProduct } from './program-product.interface';
import { InputField } from '../../shared/models';

export interface QuoteProductInformation {
    isProductValid: boolean;
    businessUnit: InputField<string> | string;
    path: InputField<string> | string ;
    language: InputField<string> | string;
    programProducts: Array<ProgramProduct>;
}